import React, { useState, useEffect } from 'react';
import {
  useQueryParams,
  StringParam,
  withDefault,
  NumberParam,
} from 'use-query-params';
import { useTranslation } from 'react-i18next';

import { useAlert } from 'react-alert';
import { useLoading } from '../../../commons/Loading';

import contractsAPIs, {
  deleteRecurringFeeFile,
} from '../../../lib/fetch/contractsAPIs';
import EnergyRecurringPresentational from './EnergyRecurringPresentational';
import { useAuth } from '../../../commons/Auth';
import axios from 'axios';
import moment from 'moment';
import { getSignedUrl } from '../../../lib/fetch/files';
const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const ContractsRecurring = ({ profile }) => {
  const [contracts, setContracts] = useState([]);
  const [total, setTotal] = useState(0);
  const [totPod, setTotPod] = useState(0);
  const [totPdr, setTotPdr] = useState(0);
  const [{ newToken } = {}] = useAuth();
  const [t] = useTranslation();
  const { showLoading, hideLoading } = useLoading();
  const [hasImportedContracts, setHasImportedContracts] = useState(false);
  const [hasImportedContractsPolis, setHasImportedContractsPolis] =
    useState(false);
  const [contractsImportFeedbackData, setContractsImportFeedbackData] =
    useState({});
  const [
    contractsImportFeedbackDataPolis,
    setContractsImportFeedbackDataPolis,
  ] = useState({});

  const [selectedContracts, setSelectedContracts] = useState([]);
  const [checkedRows, setCheckedRows] = useState([]);

  const [selectedAll, setSelectedAll] = useState(false);
  const alert = useAlert();

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    pod_pdr: withDefault(StringParam, ''),
    condo_admin_cf: withDefault(StringParam, ''),
    condo_vat_cf: withDefault(StringParam, ''),
    address: withDefault(StringParam, ''),
    customer: withDefault(StringParam, ''),
    dateFeeYear: withDefault(NumberParam, new Date().getFullYear()),
    dateFeeMonth: NumberParam,
    paid: withDefault(StringParam, ''),
    contractType: withDefault(StringParam, ''),
  });

  const {
    limit,
    offset,
    admin,
    condo_vat_cf,
    condo_admin_cf,
    pod_pdr,
    customer,
    dateFeeYear,
    dateFeeMonth,
    paid,
    contractType,
  } = query;

  const toggleShowImportFeedback = () => setHasImportedContracts((v) => !v);
  const toggleShowImportFeedbackPolis = () =>
    setHasImportedContractsPolis((v) => !v);

  function onFilter(queryDiff) {
    if (
      (queryDiff.admin && queryDiff.admin !== admin) || // first search
      (admin && queryDiff.admin === '') || // search deleted
      (queryDiff.pod_pdr && queryDiff.pod_pdr !== pod_pdr) || // first search
      (pod_pdr && queryDiff.pod_pdr === '') ||
      (queryDiff.dateFeeYear && queryDiff.dateFeeYear !== dateFeeYear) || // first search
      (dateFeeYear && queryDiff.dateFeeYear === '') || // search deleted
      (queryDiff.dateFeeMonth && queryDiff.dateFeeMonth !== dateFeeMonth) || // first search
      (dateFeeMonth && queryDiff.dateFeeMonth === '') || // search deleted
      (queryDiff.customer && queryDiff.customer !== customer) || // first search
      (customer && queryDiff.customer === '') || // search deleted
      (queryDiff.condo_vat_cf && queryDiff.condo_vat_cf !== condo_vat_cf) || // first search
      (condo_vat_cf && queryDiff.condo_vat_cf === '') || // search deleted
      (queryDiff.condo_admin_cf &&
        queryDiff.condo_admin_cf !== condo_admin_cf) || // first search
      (condo_admin_cf && queryDiff.condo_admin_cf === '') || // search deleted
      (queryDiff.paid && queryDiff.paid !== paid) || // first search
      (paid && queryDiff.paid === '') || // search deleted
      (queryDiff.contractType && queryDiff.contractType !== contractType) || // first search
      (contractType && queryDiff.contractType === '') || // search deleted
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  const fetchContracts = async (query) => {
    showLoading();

    const {
      data,
      total: _total,
      totPdr,
      totPod,
    } = await contractsAPIs.findUserRecurrentContracts({
      newToken,
      query,
      userId: profile._id,
    });
    setTotal(Number(_total || 0));
    setTotPod(totPod);
    setTotPdr(totPdr);
    setContracts(data);

    hideLoading();
  };

  useEffect(() => {
    if (profile?._id) {
      fetchContracts({
        pod_pdr,
        condo_vat_cf,
        condo_admin_cf,
        offset,
        limit,
        customer,
        dateFeeYear,
        dateFeeMonth,
        paid,
        contractType,
      });
    }
  }, [
    profile,
    condo_vat_cf,
    pod_pdr,
    condo_admin_cf,
    offset,
    limit,
    customer,
    dateFeeYear,
    dateFeeMonth,
    paid,
    contractType,
  ]);

  const onSelectChange = (row) => {
    if (selectedContracts.includes(row._id)) {
      setSelectedAll(false);
      setCheckedRows((checkedRows) =>
        checkedRows.filter(({ _id }) => _id !== row._id)
      );
      return setSelectedContracts((selectedContracts) =>
        selectedContracts.filter((contractId) => contractId !== row._id)
      );
    }
    setSelectedContracts((selectedContracts) => [
      ...selectedContracts,
      row._id,
    ]);
    setCheckedRows((checkedRows) => [...checkedRows, row]);
  };

  const onSelectAll = (selectAll) => {
    setSelectedAll(selectAll);
    if (!selectAll) {
      setCheckedRows([]);
      return setSelectedContracts([]);
    }
    setCheckedRows(
      contracts.filter(
        (contract) => contract.pinvInvoice?.length === 0 && contract.paid
      )
    );
    setSelectedContracts(
      contracts
        .filter(
          (contract) => contract.pinvInvoice?.length === 0 && contract.paid
        )
        .map(({ _id }) => _id)
    );
  };

  const onInvoice = async () => {
    showLoading();

    const dataFeeYear = moment(checkedRows[0]?.dateFee).year();

    for (const row of checkedRows) {
      const rowYear = moment(row.dateFee).year();
      if (rowYear !== dataFeeYear) {
        alert.error(
          'I contratti selezionati presentano anni di rinnovo differenti.'
        );
        hideLoading();
        return;
      }
    }

    const totalToInvoice = Number(
      checkedRows
        .reduce(
          (total, row) =>
            total + Number(Number(row.extraShare || 0).toFixed(2)),
          0
        )
        .toFixed(2)
    );

    if (totalToInvoice <= 0) {
      alert.error(t('COMMON:ERROR_TOTAL_TO_INVOICE_0'));
      hideLoading();
      return;
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/extra-invoices/${profile._id}/contracts/recurrent`,
      {
        selectedContracts,
      },
      {
        headers: { Authorization: newToken },
      }
    );
    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    alert.success(t('COMMON:SUCCESS_UPDATE'));

    fetchContracts({
      pod_pdr,
      condo_vat_cf,
      condo_admin_cf,
      offset,
      limit,
      paid,
      contractType,
    });
    setSelectedContracts([]);
    setSelectedAll(false);
  };

  const onAddPayment = async ({ contractId, data }) => {
    showLoading();

    const endpoint =
      profile.polis === true
        ? `${process.env.REACT_APP_API_URL}/contracts/recurrent/${contractId}/payments-polis`
        : `${process.env.REACT_APP_API_URL}/contracts/recurrent/${contractId}/payments`;

    let response;
    try {
      response = await axios.put(endpoint, data, {
        headers: { Authorization: newToken },
      });
    } catch (error) {
      response = error;
    }

    if (response instanceof Error) {
      hideLoading();
      const detail =
        response?.response?.data?.message || t('COMMON:GENERIC_ERROR');
      return alert.error(detail);
    }

    hideLoading();

    alert.success(t('COMMON:SUCCESS_UPDATE'));
    fetchContracts();
  };

  const onImportContractPaids = async (file) => {
    showLoading();
    const { error, data } = await contractsAPIs.importContractsPaids({
      profileId: profile._id,
      newToken,
      file,
    });
    hideLoading();
    toggleShowImportFeedback();
    setContractsImportFeedbackData({
      ...data,
      validationErrors: error?.response?.data,
    });
    fetchContracts();
    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
    }
  };

  const onImportContractPaidsPolis = async (file) => {
    showLoading();
    const { error, data } = await contractsAPIs.importContractsPaidsPolis({
      profileId: profile._id,
      newToken,
      file,
    });
    hideLoading();
    toggleShowImportFeedbackPolis();
    setContractsImportFeedbackDataPolis({
      ...data,
      validationErrors: error?.response?.data,
    });
    fetchContracts();
    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
    }
  };

  async function handleFileListView(key) {
    showLoading();

    const { data, error } = await getSignedUrl(key, newToken);

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    hideLoading();
    window.open(data.url, '_blank');
  }

  async function handleDelete({ contractId, key }) {
    showLoading();

    const { error, data } = await deleteRecurringFeeFile({
      contractId,
      key,
      newToken,
    });

    if (error) {
      hideLoading();

      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    fetchContracts();
    alert.success(t('COMMON:SUCCESS_DELETE'));
  }

  return (
    <EnergyRecurringPresentational
      data={contracts}
      profile={profile}
      query={query}
      total={total}
      totPod={totPod}
      totPdr={totPdr}
      onFilter={onFilter}
      selectedContracts={selectedContracts}
      onInvoice={onInvoice}
      selectedAll={selectedAll}
      onSelectAll={onSelectAll}
      onSelectChange={onSelectChange}
      onStatusChanged={() => fetchContracts()}
      onAddPayment={onAddPayment}
      onImportContractPaids={onImportContractPaids}
      onImportContractPaidsPolis={onImportContractPaidsPolis}
      contractsImportFeedbackData={contractsImportFeedbackData}
      contractsImportFeedbackDataPolis={contractsImportFeedbackDataPolis}
      hasImportedContracts={hasImportedContracts}
      hasImportedContractsPolis={hasImportedContractsPolis}
      toggleShowImportFeedback={toggleShowImportFeedback}
      toggleShowImportFeedbackPolis={toggleShowImportFeedbackPolis}
      handleFileListView={handleFileListView}
      handleDelete={handleDelete}
    />
  );
};

export default ContractsRecurring;
